import axios from "axios";

export const axiosAuthInstance = axios.create({
    baseURL: `${process.env.REACT_APP_NOT_SECRET_SERVICE_URL}/webapi/adminreporting`,
    headers: { "Content-Type": "application/json" },
  });